import { Form } from 'antd';
import { useState } from 'react';

import { useNewUserAccessRights } from '@app/hooks';
import type { NFunnels } from '@app/types';

const { useForm } = Form;

export const useEditSalesFunnel = () => {
  const [isEditSalesFunnelModalOpen, setIsEditSalesFunnelModalOpen] =
    useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [editableSalesFunnelId, setEditableSalesFunnelId] = useState(0);
  const [currentSalesFunnelStage, setCurrentSalesFunnelStage] =
    useState<NFunnels.SalesFunnelStageFilterListDto>();

  const [headerForm] = useForm();

  const {
    userAccessRights: {
      SalesFunnels: { IsStageCreate },
    },
  } = useNewUserAccessRights();

  const handleOpenSalesFunnelModal = (
    salesFunnelId: number,
    isEditModal: boolean
  ) => {
    setIsEditSalesFunnelModalOpen(true);
    setEditableSalesFunnelId(salesFunnelId);
    setIsEditModal(isEditModal);
  };

  return {
    handleOpenSalesFunnelModal,
    isEditSalesFunnelModalOpen,
    isEditModal,
    editableSalesFunnelId,
    setIsEditSalesFunnelModalOpen,
    headerForm,
    currentSalesFunnelStage,
    setCurrentSalesFunnelStage,
    IsStageCreate,
  };
};
